import React from 'react';
import { Flex, Text, Link } from 'rebass/styled-components';

export const PoweredByFooter = () => (
  <Flex
    sx={{
      position: 'fixed',
      bottom: 0,
      right: 0,
      bg: 'neutral.20',
      px: '16px',
      py: '8px',
      borderTopLeftRadius: '8px',
      gap: '4px',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      color: 'text.subtle',
    }}
  >
    <Text>Powered by</Text>
    <Link
      href="https://www.getro.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'text.subtle',
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      Getro.com
    </Link>
    <Text>·</Text>
    <Link
      href="https://www.getro.com/terms"
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'text.subtle',
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      Terms
    </Link>
    <Text>·</Text>
    <Link
      href="https://www.getro.com/privacy"
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'text.subtle',
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      Privacy
    </Link>
  </Flex>
);
